<template>
  <modal
    :is-displayed="isCreateModalOpened"
    :no-padding="true"
    :title="$t('Organizations.CreateTitle')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <form-wrapper :is-form-in-modal="true">
      <form @submit.prevent="handleSubmit">
        <form-divider>
          <input-field
            v-model="formData.name"
            :errorMessage="v$?.formData['name']?.$errors[0]?.$message"
            :isError="v$?.formData['name']?.$error"
            :label="$t('Organizations.Name')"
            :required="true"
          />
        </form-divider>
        <button-wrapper :is-submit-loading="isSubmitLoading" />
      </form>
    </form-wrapper>
  </modal>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import MainSection from "../../../core/Components/MainSection.vue";
import Loader from "../../../core/Components/Loader.vue";
import FormWrapper from "@/core/Components/FormElements/FormWrapper.vue";
import InputField from "@/core/Components/FormElements/InputField.vue";
import TheButton from "@/core/Components/TheButton.vue";
import CompanyService from "../Services/CompanyService";
import ToastComponent from "@/core/Components/Notifications/ToastComponent.vue";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";
import { useSidebarStore } from "@/core/Store";
import { maxLength, required, helpers } from "@vuelidate/validators";
import useValidate from "@vuelidate/core";
import ButtonWrapper from "@/core/Components/FormElements/ButtonWrapper.vue";
import FormDivider from "@/core/Components/FormElements/FormDivider.vue";
import { useToast } from "vue-toastification";
import Modal from "@/core/Components/Modal.vue";
import { specialCharactersValidator } from "@/core/Services/CustomValidators";

export default defineComponent({
  components: {
    MainSection,
    Loader,
    FormWrapper,
    InputField,
    TheButton,
    ToastComponent,
    ButtonWrapper,
    FormDivider,
    Modal,
  },
  props: { isCreateModalOpened: Boolean, refreshData: Function },
  data() {
    return {
      v$: useValidate() as any,
      validationErrors: [] as any,
      companyService: new CompanyService(),
      isLoading: false as boolean,
      isSubmitLoading: false as boolean,
      sidebarStore: useSidebarStore(),
      toast: useToast(),
      formData: {
        name: "",
      },
    };
  },
  validations() {
    return {
      formData: {
        name: {
          required,
          maxLength: maxLength(50),
          specialCharacters: specialCharactersValidator,
        },
      },
    };
  },
  methods: {
    async handleSubmit() {
      this.v$.$validate();
      this.validationErrors = this.v$.$errors;
      if (!this.v$.$error) {
        this.isSubmitLoading = true;
        try {
          await this.companyService.createCompany(this.formData);
          location.reload();
          this.toast.success((this as any).$t("General.CreatedSuccessfully"));
          this.$emit("toggle-modal");
          await this.refreshData?.();
        } catch (error: any) {
          this.toast.error(ErrorMessageFormatter(error));
        } finally {
          this.isSubmitLoading = false;
        }
      }
    },
  },
});
</script>
<style scoped></style>
